import { Divider, Typography } from "@mui/material";
import DownloadPdf from "components/Downloads/CreatePDF";
import PreviewInvoice from "./PreviewInvoice";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { invoiceGetAllActionById } from "actions/invoiceActions";
import { getInvoiceData } from "selectors/invoiceSelector";

export const DownloadInvoice = ({
  selectedInvoice,
  handleDownloadComplete,
  projectData,
  type = "view",
}) => {
  const dispatch = useDispatch();

  const invoiceData = useSelector(getInvoiceData);

  useEffect(() => {
    if (selectedInvoice?.invoiceId)
      dispatch(invoiceGetAllActionById(selectedInvoice.invoiceId));
  }, [dispatch, selectedInvoice]);

  if (invoiceData?.invoiceNumber) {
    if (type === "view") {
      return (
        <PreviewInvoice
          formData={invoiceData}
          invoiceItems={invoiceData?.invoiceItemsList || []}
          isModal={true}
        />
      );
    }
    return (
      <div>
        <DownloadPdf
          shouldSavePDF={true}
          onDownloadComplete={handleDownloadComplete}
          fileName={invoiceData?.invoiceNumber || "Invoice.pdf"}
          contentInlineStyles={{}}
        >
          {/* Pass RenderTemplate and other content to the PDF */}
          <div>
            {/* <Typography className="h4">
              Invoice Receipt - {invoiceData?.invoiceNumber}
            </Typography>
            <Divider className="divider" /> */}
            <PreviewInvoice
              formData={invoiceData}
              invoiceItems={invoiceData?.invoiceItemsList || []}
              isModal={true}
            />
          </div>
        </DownloadPdf>
      </div>
    );
  }
  return <div>Loading...</div>;
};

export default DownloadInvoice;
